import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { StorageBase } from "./storage-base";
let SessionStorageService = class SessionStorageService extends StorageBase {
    constructor() {
        super(window.sessionStorage);
    }
    static ctorParameters = () => [];
};
SessionStorageService = __decorate([
    Injectable({
        providedIn: "root"
    })
], SessionStorageService);
export { SessionStorageService };
